import React, { useEffect } from 'react';

const ExplorerContextMenu = ({ x, y, items, onClose }) => {
  useEffect(() => {
    const close = () => onClose();
    window.addEventListener('click', close);
    window.addEventListener('scroll', close, true);
    window.addEventListener('contextmenu', close);
    return () => {
      window.removeEventListener('click', close);
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('contextmenu', close);
    };
  }, [onClose]);

  if (!items || !items.length) return null;

  return (
    <ul
      className="dropdown-menu show shadow"
      style={{
        position: 'fixed',
        left: x,
        top: y,
        zIndex: 1050,
        display: 'block',
        minWidth: 180,
      }}
      onClick={(e) => e.stopPropagation()}
      onContextMenu={(e) => e.preventDefault()}
    >
      {items.map((item) =>
        item.divider ? (
          <div key={item.key} className="dropdown-divider" />
        ) : (
          <button
            key={item.key}
            type="button"
            className={`dropdown-item ${item.danger ? 'text-danger' : ''}`}
            disabled={item.disabled}
            onClick={() => {
              onClose();
              item.onClick && item.onClick();
            }}
          >
            {item.label}
          </button>
        ),
      )}
    </ul>
  );
};

export default ExplorerContextMenu;
